import classNames from "@calcom/ui/classNames";

export function getBookerWrapperClasses({ isEmbed }: { isEmbed: boolean }) {
  // We don't want any margins for Embed. Any margin needed should be added by Embed user.
  // The top padding keeps the company mark (PublicBrandHeader, absolutely positioned at the
  // document's top left) clear of the event meta column, which starts at y=0 whenever the
  // booker is taller than the viewport - the week and column layouts on a laptop screen.
  return classNames("flex h-full items-center justify-center", !isEmbed && "min-h-[calc(100dvh)] pt-16");
}
